import React, { Component } from 'react';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';

import { Route, Switch } from "react-router-dom";
import PrivateRoute from "../services/PrivateRoute";
import * as actionCreator from '../redux-store/redux-actions/index';


import FrontPage from '../views/FrontPage/FrontPage';
import DetailProduct from '../views/DetailProduct/DetailProduct';
import ProductSearch from '../views/ProductSearch/ProductSearch';
import ProductPerpusnas from '../views/ProductPerpusnas/ProductPerpusnas';
import Checkout from '../views/Checkout/Checkout';


import LoginRegister from '../components/LoginRegister/LoginRegister';
import { connect } from 'react-redux';
import SignUpLogIn from '../views/SignUpLogIn/SignUpLogIn';
import Logout from '../services/Logout';
import Thanks from '../views/Thanks/Thanks';
import FailedPayment from '../views/FailedPayment/FailedPayment';
import ProfilePage from '../views/ProfilePage/ProfilePage';
import OrderDetail from '../views/OrderDetail/OrderDetail';
import Invoice from '../views/OrderDetail/Invoice/Invoice';
import { Helmet } from "react-helmet";
import ProductNew from '../views/ProductNew/ProductNew';
import ProductFits from '../views/ProductNew/ProductFits';
import ProductBook from '../views/ProductNew/ProductBook';
import ProductKitchen from '../views/ProductNew/ProductKitchen';


class StoreLayout extends Component {

    
    render() {
        return (
            <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>POINT OF SALES</title>
                <meta name="description" content=" PT IPB Press hadir sejak tahun 2009 sebagai perusahaan 
                penerbitan yang memiliki fokus menyalurkan ilmu dan hasil riset penelitian kepada masyarakat 
                luas agar tercipta kemajuan industri pertanian, kelautan, dan biosains tropika yang berdaya saing dan berkelanjutan."></meta>
                <meta name="author" content="IPB PRESS"></meta>
                

                <meta property="og:title" content="IPB PRESS BOOKSTORE"></meta>
                <meta property="og:url" content="ipbpress.com"></meta>
                <meta property="og:author" content="IPB PRESS"></meta>             
            </Helmet>
            <div className="wrapper">
                {this.props.isModalAuthOpen ? (
                    <LoginRegister />
                ) : null}
                <Header />
                <div className="main-page">
                    <Switch>
                        <Route path="/" exact component={FrontPage}></Route>
                        <Route path="/product/search" component={ProductSearch}></Route>
                         <Route path="/product/newproduct" component={ProductNew}></Route>
                         <Route path="/product/fitsproduct" component={ProductFits}></Route>
                         <Route path="/product/bookproduct" component={ProductBook}></Route>
                         <Route path="/product/kitchenproduct" component={ProductKitchen}></Route>

                        <Route path="/product/category/:nameCat" component={ProductSearch}></Route>
                       
                        <Route path="/product/:id" exact component={DetailProduct}></Route>
                        <Route path="/signup-login" exact component={SignUpLogIn}></Route>
                        <Route path="/logout" exact component={Logout}></Route>
                        <PrivateRoute path="/checkout" exact isAuth={this.props.auth} component={Checkout}></PrivateRoute>
                        <PrivateRoute path="/checkout/thanks/:id" exact isAuth={this.props.auth} component={Thanks}></PrivateRoute>
                        {/* <PrivateRoute path="/payment/failed/:id" exact isAuth={this.props.auth} component={FailedPayment}></PrivateRoute> */}
                        <PrivateRoute path="/user" isAuth={this.props.auth} component={ProfilePage}></PrivateRoute>
                        <PrivateRoute path="/order/detail/:id" exact isAuth={this.props.auth} component={OrderDetail}></PrivateRoute>
                        <PrivateRoute path="/order/invoice/:id" exact isAuth={this.props.auth} component={Invoice}></PrivateRoute>
                    </Switch>

                </div>
                <Footer />
            </div>
            </>
        )
    }
}

const mapStateToProps = state => {
    return {
        isModalAuthOpen: state.auth.modalShow,
        auth:state.auth.isAuth
    }
}

const mapDispatchToProps = dispatch => {
    return {
       OpenAuthModal: ()=>dispatch(actionCreator.openModalAuth())
    }
}


export default connect(mapStateToProps,mapDispatchToProps)(StoreLayout);